<template>
  <div class="ae-toolbar d-flex">
    <span v-for="(button, index) in visibleButtons" :key="index" class="p-2 item-image dropdown-item icon" :class="(button.hasOwnProperty('small') && button.small) ? [button.icon, 'small'] : [button.icon]" @click="additionalData ? $emit('clicked', index, additionalData, button) : $emit('clicked', index, button)" :id="button.id" :content="!button.htmlContent ? $t(button.tip) : button.tip" v-tippy></span>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    additionalData: String,
    buttons: Array
  },
  computed: {
    visibleButtons () {
      return this.buttons.filter(btn => {
        if (!btn.hasOwnProperty('visible') || btn.visible) {
          return true
        }
        return false
      })
    }
  }
}
</script>

<style>
.ae-toolbar > .item-image {
  font-size: 20px;
  align-items: center;
  height: 33px !important;
  width: 33px !important;
}
.ae-toolbar > .small {
  font-size: 14px;
  height: 28px !important;
  width: 28px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniToolbar.vue